import { atom, getDefaultStore } from 'jotai';
import { TableDataState, TableFilters, TableState, TblStats, TblView } from '../../../core/table/table.types';
import { tableStatsVM, tableViewVM } from '../../../core/table/table_view_models';
import { FeedsDataItem, FeedsListPageState } from './feeds_list_types';
import tableViewRepo from '../../../core/repo/viewStateRepo';
import { FEEDS_LIST_STORAGE_KEY } from '../feeds_const';
import { tableStateVM } from '../../../core/table/table_view_models';
import { feedsListPageStateVM } from './feeds_list_view_models';
import { OpsFeedsSearchModel } from './search/feeds_search_types';
import { feedsSearchFormAtom } from './search/feeds_search_atoms';
import { stripAwayFormErrors } from '../../../core/table/utils/stripAwayFormErrors';

// FEEDS_LIST_STORAGE_KEY and FEEDS_LIST_FORM_KEY are missing, so define them here for now
export const FEEDS_LIST_FORM_KEY = 'admin-feeds-list-form';

// USER CONTEXT — set once in useFeedsInit, read by sub-components via useAtomValue
export type FeedsUserContext = {
    userType: string;
    isImpersonating: boolean;
    affiliations: any[];
};

export const feedsUserContextAtom = atom<FeedsUserContext>({
    userType: 'CE',
    isImpersonating: false,
    affiliations: [],
});

// PAGE
export const feedsPageStateAtom = atom<FeedsListPageState>(feedsListPageStateVM());
export const feedsPageActionAtom = atom(get => get(feedsPageStateAtom).action);

export const tableStateAtom = atom<TableState>(tableStateVM());
export const tableViewAtom = atom<TblView>(tableViewVM());
export const tableFiltersAtom = atom<TableFilters>({});
export const tableStatsAtom = atom<TblStats>(tableStatsVM());
export const feedsDataAtom = atom<TableDataState<FeedsDataItem>>({ items: [], dataItems: [] });

export function setAtomFeedsListTableViewState(atomsDestroyed: boolean = false): void {
    // on Table exit save viewstate
    // note this can read the current Jotai values without subscribing (Jotai accessors)
    if (atomsDestroyed) {
        console.log('[FeedsAtoms] setAtomFeedsListTableViewState skipped: atoms already destroyed');
        return;
    }
    const defaultStore = getDefaultStore();
    const flt = defaultStore.get<TableFilters>(tableFiltersAtom);
    const stats = defaultStore.get<TblStats>(tableStatsAtom);
    const view = defaultStore.get<TblView>(tableViewAtom);
    console.log('[FeedsAtoms] setAtomFeedsListTableViewState persisting sort:', JSON.stringify(view.sort));
    tableViewRepo.setTable(FEEDS_LIST_STORAGE_KEY, flt, stats.paging, view.sort);
}

export function setAtomFeedsFormState(): void {
    // on Table exit save viewstate
    const defaultStore = getDefaultStore();
    const formState = defaultStore.get<OpsFeedsSearchModel>(feedsSearchFormAtom);
    tableViewRepo.setForm(FEEDS_LIST_FORM_KEY, stripAwayFormErrors(formState));
}
